export const group = (state, id) => state.data.groups.groups[id];

export const groupSet = (state, id) => state.data.groups.sets[id];

export const groupSetsIds = (state, space = null) =>
  Object.keys(state.data.groups.sets).filter(
    (setId) => !space || groupSet(state, setId).space === space
  );

export const setsAugmentedWithGroups = (state, space = null) =>
  Object.values(state.data.groups.sets)
    .filter((set) => !space || set.space === space)
    .map((set) => ({
      ...set,
      groups: set.groups.map((groupId) => group(state, groupId)),
    }));

export const groupNamesByStudentId = (state, userId) =>
  Object.values(state.data.groups.groups)
    .filter(({ students }) => students.includes(userId))
    .map(({ name }) => name);

export const isCreateGroupSetDialogOpen = (state) =>
  state.groups.createGroupSetDialogOpen;
export const editGroupSetDialogOpenFor = (state) =>
  state.groups.editGroupSetDialogOpenFor;
export const createGroupDialogOpenFor = (state) =>
  state.groups.createGroupDialogOpenFor;
export const editGroupDialogOpenFor = (state) =>
  state.groups.editGroupDialogOpenFor;
export const generateGroupsDialogOpenFor = (state) =>
  state.groups.generateGroupsDialogOpenFor;

export const isCreatingGroupSet = (state) => state.groups.creatingGroupSet;
export const isEditingGroupSet = (state) => state.groups.editingGroupSet;
export const isDeletingGroupSet = (state) => state.groups.deletingGroupSet;
export const isCreatingGroup = (state) => state.groups.creatingGroup;
export const isEditingGroup = (state) => state.groups.editingGroup;
export const isDeletingGroup = (state) => state.groups.deletingGroup;
export const isGeneratingGroups = (state) => state.groups.generatingGroups;
